import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporateeventshoisting() {



    const cardData =
    {
        keyword: 'Corporate Event Hosting Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Corporate Event Hosting Morachi Chincholi Pune',
        headingDescription: 'Planning a unique and refreshing venue for your next off-site or team-building session? Anand Krushi Paryatan Kendra offers a perfect setting for corporate event hosting Morachi Chincholi Pune, just 55 km from the city. Nestled across 40 acres of serene green farmland, this agri-tourism destination blends rustic charm with modern amenities for a productive and enjoyable corporate retreat. Ideal for seminars, workshops, team-building activities, and annual celebrations, the venue offers a range of rural experiences—from bullock cart and tractor rides to boating, horse riding, rain dance, and more. Traditional village games, cultural performances, and open spaces promote bonding and relaxation among team members.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Open-Air Conference Setups",
    "description": "Host your corporate gathering amidst nature with farm-side pavilions or shaded outdoor stages. Setup includes PA systems, seating arrangements, and flexible layouts—ideal for presentations, awards, or team addresses in a relaxed environment."
  },
  {
    "title": "Team-Building Games & Activities",
    "description": "Strengthen workplace bonds through engaging outdoor challenges like tug-of-war, lagori, sack races, and problem-solving games. These classic activities bring teams together through fun and laughter."
  },
  {
    "title": "Tractor & Bullock Cart Welcome Ride",
    "description": "Kick off your event with a unique rural welcome—teams arrive on decorated tractors or bullock carts, setting a cheerful and memorable tone for the day. It’s a great photo-op and icebreaker too."
  },
  {
    "title": "Maharashtrian Farm-Style Meals",
    "description": "Enjoy unlimited veg thalis served with warmth on banana leaves, featuring pithla, zunka, varan-bhat, bhakri, and seasonal desserts. Meals are hosted in open-air dining areas with folk music in the background."
  },
  {
    "title": "Rain Dance & Water Zone Breaks",
    "description": "Add high-energy fun to your corporate day out with a DJ-led rain dance and splash pool access. Perfect for refreshing your team after meetings or activities—especially popular during summer months."
  },
  {
    "title": "Nature Trail Walks & Bird Watching",
    "description": "Take a calm break with guided walks through fields and shaded trails. Spot birds like kingfishers, bulbuls, and peacocks. These peaceful intervals offer relaxation and informal networking moments."
  },
  {
    "title": "Adventure Rope & Obstacle Courses",
    "description": "Challenge your team’s coordination and communication through rope bridges, balancing planks, and low-height climbing stations. These rustic adventure games are designed to boost confidence and trust."
  },
  {
    "title": "Interactive Farming & Animal Tours",
    "description": "Explore vegetable patches, dairy sheds, and organic plots. Employees can try milking cows or feeding animals—turning a simple outing into a unique, hands-on agro-tourism experience."
  },
  {
    "title": "Evening Bonfire & Entertainment",
    "description": "Close the day with a cozy bonfire, light snacks, and folk or DJ music. Whether it's for unwinding or celebrating, the bonfire session offers an ideal space to connect and reflect as a team."
  },
  {
    "title": "Overnight Stay Packages for Teams",
    "description": "For extended events or two-day retreats, book traditional cottages or dorms with modern amenities. Group stays include food, activity access, and cozy village hospitality for a memorable escape."
  }
],




"services": [
  {
    "name": "Corporate Event Venues in Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra provides a serene yet vibrant setting for corporate events, combining professional amenities with a rural backdrop. It's ideal for hosting small to mid-sized office events, employee appreciation days, and departmental meet-ups with a refreshing farm ambiance."
  },
  {
    "name": "Outdoor Meeting Spaces Near Pune",
    "description": "Break away from traditional boardrooms with our well-equipped open-air meeting setups. With shaded seating, whiteboard/projector support, and Wi-Fi on request, it’s a unique way to spark creativity in natural surroundings, just 1.5 hours from Pune."
  },
  {
    "name": "Team-Building Activities in Rural Settings",
    "description": "We organize curated team-building modules like obstacle courses, trust games, village-style competitions, and collaborative farming experiences that help strengthen communication, leadership, and camaraderie among colleagues."
  },
  {
    "name": "Seminar and Workshop Space Near Pune",
    "description": "Our semi-open event shelters and covered spaces can accommodate presentations, training sessions, and skill-based workshops with ease. Perfect for HR-led development events, wellness sessions, or team briefings."
  },
  {
    "name": "Conference + Outing Combo",
    "description": "Combine your business agenda with relaxation and bonding. Conduct your morning meeting in our event zone, then follow it up with lunch, nature walks, and cultural experiences to turn a regular meeting into a memorable offsite."
  },
  {
    "name": "Nature-Inspired Corporate Events",
    "description": "Host your leadership retreats or planning meetings amidst greenery and clean air. The setting promotes clarity, reduces stress, and inspires fresh ideas—ideal for quarterly reviews, brainstorms, or goal-setting days."
  },
  {
    "name": "Event Space with Lunch and Refreshments",
    "description": "Our packages include traditional Maharashtrian meals, farm-fresh snacks, and refreshments like buttermilk, lemon juice, or Aamras (seasonal). Special dietary options and customized menus are also available for corporate groups."
  },
  {
    "name": "Group Bonding Games",
    "description": "Lighten up the work vibe with interactive rural games, relay races, and light-hearted competitions. We facilitate activities that foster team spirit, laughter, and bonding—perfect for post-meeting engagement."
  },
  {
    "name": "Offsite Meeting Venue in Nature",
    "description": "Anand Krushi Paryatan Kendra is a popular offsite choice for Pune-based companies. With ample space, privacy, and easy access from the city, it’s ideal for teams looking for a peaceful yet productive day."
  },
  {
    "name": "Eco-Friendly Event Hosting",
    "description": "We follow sustainable practices like minimal plastic usage, organic food options, composting, and reusable serveware—making your corporate event not just impactful, but environmentally conscious as well."
  },
  {
    "name": "Small Corporate Event Halls",
    "description": "We offer covered and semi-open halls suitable for smaller corporate groups of 30–80 participants. These spaces can be used for presentations, employee trainings, strategy sessions, or closed group workshops."
  },
  {
    "name": "Full-Day Event Planning for Offices",
    "description": "From event scheduling and group activity coordination to meals and breakout zones, our team offers end-to-end planning support for hassle-free corporate outings. You focus on your agenda—we handle the rest."
  },
  {
    "name": "Corporate Team Retreat Packages",
    "description": "Enjoy customizable packages that include meeting space, team games, cultural programs, meals, and guided nature experiences. Ideal for HR departments planning retreats or employee reward trips."
  },
  {
    "name": "Open Lawn Events for Companies",
    "description": "Host awards, fun fairs, or casual corporate celebrations in our spacious lawns. With ample natural shade, scenic farm surroundings, and space for event branding, your gathering will feel lively and relaxing."
  },
  {
    "name": "Affordable Event Packages for Corporates",
    "description": "Our corporate packages are designed to be cost-effective without compromising on experience. We offer special rates for large teams, repeat clients, and weekday bookings—ideal for start-ups and MSMEs."
  }
],
"tableData": [
  ["Corporate Event Venues in Morachi Chincholi", "- Outdoor Meeting Spaces Near Pune"],
  ["Team-Building Activities in Rural Settings", "- Seminar and Workshop Space Near Pune"],
  ["Conference + Outing Combo", "- Nature-Inspired Corporate Events"],
  ["Event Space with Lunch and Refreshments", "- Group Bonding Games"],
  ["Offsite Meeting Venue in Nature", "- Eco-Friendly Event Hosting"],
  ["Small Corporate Event Halls", "- Full-Day Event Planning for Offices"],
  ["Corporate Team Retreat Packages", "- Open Lawn Events for Companies"],
  ["Affordable Event Packages for Corporates", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Ideal Venue for Team Building",
    "WhyChoosedescription": "Morachi Chincholi offers a serene and spacious environment perfect for corporate team-building activities, outdoor challenges, and leadership workshops that foster collaboration and communication."
  },
  {
    "WhyChooseheading": "Customizable Corporate Packages",
    "WhyChoosedescription": "With tailored packages that include meeting spaces, adventure activities, and group meals, businesses can customize their event to suit their goals and budgets, ensuring a productive and enjoyable experience."
  },
  {
    "WhyChooseheading": "Unique Rural Ambiance",
    "WhyChoosedescription": "Set amidst lush greenery and vibrant wildlife, the location provides a refreshing break from office settings, inspiring creativity and relaxation for corporate teams."
  },
  {
    "WhyChooseheading": "Comprehensive Facilities",
    "WhyChoosedescription": "The venue includes facilities like conference halls, outdoor activity zones, catering services, and accommodation options, making it a convenient one-stop destination for corporate events."
  },
  {
    "WhyChooseheading": "Convenient Proximity to Pune",
    "WhyChoosedescription": "Located just 55 km from Pune, Morachi Chincholi is easily accessible, allowing companies to organize day-long or overnight corporate events without extensive travel."
  },
  {
    "WhyChooseheading": "Engaging Recreational Activities",
    "WhyChoosedescription": "From zip-lining and rope courses to cultural programs and bonfires, the destination offers a variety of fun activities that enhance team bonding and employee morale."
  }
]

























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Can corporate events be hosted at Morachi Chincholi?',
    answer: 'Yes! Morachi Chincholi offers excellent venues and facilities for corporate events, including team-building activities and outdoor sessions.',
  },
  {
    id: 'FAQ2',
    question: 'What kind of corporate events can be organized here?',
    answer: 'You can host team-building workshops, leadership training, offsite meetings, corporate retreats, and informal get-togethers.',
  },
  {
    id: 'FAQ3',
    question: 'Are there facilities for presentations and meetings?',
    answer: 'Many resorts have conference rooms, audio-visual equipment, and seating arrangements suitable for corporate meetings and presentations.',
  },
  {
    id: 'FAQ4',
    question: 'What team-building activities are available?',
    answer: 'Activities include obstacle courses, trust exercises, group games, nature trails, and farm-based challenges designed to foster teamwork.',
  },
  {
    id: 'FAQ5',
    question: 'Are catering services available for corporate events?',
    answer: 'Yes, catering with fresh, farm-to-table meals including local Maharashtrian cuisine is available as part of corporate event packages.',
  },
  {
    id: 'FAQ6',
    question: 'Is accommodation available for overnight corporate events?',
    answer: 'Many agro-tourism resorts offer eco-friendly accommodations for overnight stays, ensuring comfort and a relaxing environment.',
  },
  {
    id: 'FAQ7',
    question: 'How far is Morachi Chincholi from Pune for corporate guests?',
    answer: 'It is about 60–65 km from Pune, approximately a 1.5 to 2-hour drive, making it convenient for day events or short retreats.',
  },
  {
    id: 'FAQ8',
    question: 'Can the event packages be customized?',
    answer: 'Yes, event organizers work closely with clients to customize packages to meet specific requirements and budgets.',
  },
  {
    id: 'FAQ9',
    question: 'What is the best time of year for corporate events here?',
    answer: 'The best time is from October to March when the weather is cool and outdoor activities can be enjoyed comfortably.',
  },
  {
    id: 'FAQ10',
    question: 'How can I book a corporate event at Morachi Chincholi?',
    answer: 'You can contact agro-tourism centers like Anand Krushi Paryatan Kendra directly for package details, availability, and booking.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikram Shah, Corporate Manager, Pune',
    feedback: "We held our annual corporate retreat at Morachi Chincholi and it was a huge success. The natural setting and activities helped boost team morale.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Joshi, HR Lead, PCMC',
    feedback: "The venue was perfect for our leadership workshop. Great facilities, delicious food, and excellent support from the staff throughout the event.",
    rating: 5,
  },
];




























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Event Hosting Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/corporate-event-morachi-chincholi.jpg",
  "description": "Host your corporate events in Morachi Chincholi with outdoor meeting spaces, team-building activities, seminar and workshop venues, conference and outing combos, nature-inspired settings, and affordable packages.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "410"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/corporate-event-hosting"
  }
};




    return (
        <div>
<Helmet>
  <title>Corporate Event Hosting Morachi Chincholi Pune | Team-building & Meetings</title>
  <meta 
    name="description" 
    content="Plan your corporate event hosting in Morachi Chincholi with outdoor meeting spaces, team-building activities, seminar venues, conference combos, nature-inspired settings, and affordable packages near Pune." 
  />
  <meta 
    name="keywords" 
    content="Corporate event venues in Morachi Chincholi, Outdoor meeting spaces near Pune, Team-building activities in rural settings, Seminar and workshop space near Pune, Conference + outing combo, Nature-inspired corporate events, Event space with lunch and refreshments, Group bonding games, Offsite meeting venue in nature, Eco-friendly event hosting, Small corporate event halls, Full-day event planning for offices, Corporate team retreat packages, Open lawn events for companies, Affordable event packages for corporates" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Corporateeventshoisting;